var v1="<div gnp-stroke-analysis=\"\" stroke-data=\"staeCtrl.strokeData\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-event/stroke-analysis/stroke-analysis.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis-event/stroke-analysis/stroke-analysis.jade
// module id = 522
// module chunks = 0